interface ThrottleOptions {
  readonly frequency: number;
  readonly disabled?: boolean;
}

export const throttle = (options: ThrottleOptions) => {
  const { frequency, disabled = false } = options;
  let counter = 1;
  let leading = true;
  return () => {
    /** Do not throttle during Cypress tests */
    if (IS_RUNNING_IN_CYPRESS === 'true') return false;
    if (disabled) return false;

    counter += 1;

    if (leading) {
      leading = false;
      return false;
    }

    if (counter > frequency) {
      counter = 1;
      return false;
    }

    return true;
  };
};
